/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  UniswapV2Oracle,
  UniswapV2OracleInterface,
} from "../UniswapV2Oracle";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "factoryAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PAIR_ADDER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address",
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address",
      },
    ],
    name: "add",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenIn",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "tokenOut",
        type: "address",
      },
    ],
    name: "consult",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "tokenIn",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "tokenOut",
        type: "address",
      },
    ],
    name: "consultAt",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "lastUpdated",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "pairAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "time",
        type: "uint256",
      },
    ],
    name: "observationAt",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "timestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "price0Cumulative",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "price1Cumulative",
            type: "uint256",
          },
        ],
        internalType: "struct UniswapV2Oracle.Observation",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pairs",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "periodSize",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address",
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address",
      },
    ],
    name: "update",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "updateAll",
    outputs: [
      {
        internalType: "bool",
        name: "updated",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "i",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "length",
        type: "uint256",
      },
    ],
    name: "updateFor",
    outputs: [
      {
        internalType: "bool",
        name: "updated",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "pair",
        type: "address",
      },
    ],
    name: "updatePair",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "updateable",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "pair",
        type: "address",
      },
    ],
    name: "updateable",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "i",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "length",
        type: "uint256",
      },
    ],
    name: "updateableFor",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "updateableList",
    outputs: [
      {
        internalType: "address[]",
        name: "list",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "windowSize",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

export class UniswapV2Oracle__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    factoryAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<UniswapV2Oracle> {
    return super.deploy(
      factoryAddress,
      overrides || {}
    ) as Promise<UniswapV2Oracle>;
  }
  getDeployTransaction(
    factoryAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(factoryAddress, overrides || {});
  }
  attach(address: string): UniswapV2Oracle {
    return super.attach(address) as UniswapV2Oracle;
  }
  connect(signer: Signer): UniswapV2Oracle__factory {
    return super.connect(signer) as UniswapV2Oracle__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): UniswapV2OracleInterface {
    return new utils.Interface(_abi) as UniswapV2OracleInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): UniswapV2Oracle {
    return new Contract(address, _abi, signerOrProvider) as UniswapV2Oracle;
  }
}
